export const DEFAULT_MAX_FILE_SIZE = 1024 * 1024 * 2;

export const DEFAULT_MAX_FILES = 5;

export const DOCUMENTS_DATE_FORMAT = 'MM/dd/yyyy';
